<template>
    <video
        class="fixed w-screen h-screen object-cover opacity-60 z-[-1] left-0 top-0"
        autoplay
        muted
        loop
        playsinline
        preload="auto"
        poster="@/assets/images/hero-bg-poster.jpg"
        aria-hidden="true"
    >
        <source src="@/assets/videos/hero-bg.webm" type="video/webm">
        <source src="@/assets/videos/hero-bg.mp4" type="video/mp4">
    </video>
</template>

<script>
export default {
  name: 'BackToTop',
}
</script>


<style scoped>

</style>
